import { Injectable } from '@angular/core';
import { Dashboard } from "./models/dashboard";


/* DashboardIdentifiers should match
Mojo.Client.Core.Domain.DashboardIdentifiers
*/
@Injectable()
export class DashboardIdentifiers {
  static AdminDashboard = 'AdminDashboardComponent';
  static ClientDashboard = 'ClientDashboardComponent';
  static ClientParentDashboard = 'ClientParentDashboardComponent';
  static CreditorDashboard = 'CreditorDashboardComponent';
  static EstateDashboard = 'EstateDashboardComponent';
  static HeadleaseDashboard = 'HeadleaseDashboardComponent';
  static HomeDashboard = 'HomeDashboardComponent';
  static IdsAdminDashboard = 'MojoAdminDashboardComponent';
  static LandlordDashboard = 'LandlordDashboardComponent';
  static LeaseDashboard = 'LeaseDashboardComponent';
  static ManagerDashboard = 'ManagerDashboardComponent';
  static DebtorDashboard = 'DebtorDashboardComponent';
  static SupplierDashboard = 'SupplierDashboardComponent';
  static MasterAdminDashboard = 'MasterAdminDashboardComponent';
  static MojoAdminDashboard = 'MojoAdminDashboardComponent';
  static PropertyDashboard = 'PropertyDashboardComponent';
  static TenantDashboard = 'TenantDashboardComponent';
  static TenantParentDashboard = 'TenantParentDashboardComponent';
  static UnitDashboard = 'UnitDashboardComponent';
  static VacantDashboard = 'VacantDashboardComponent';

  static MFS_SuppliersHomeDashboard = 'MFS_SuppliersHomeDashboard';
  static MFS_AccountDashboard = 'MFS_AccountDashboard';

  static MFT_TenantsHomeDashboard = 'MFT_TenantsHomeDashboard';
  static MFT_TenantsDashboard = 'MFT_TenantDashboard';
  static MFT_AgreementDashboard = 'MFT_AgreementDashboard';
  static MFT_AccountDashboard = 'MFT_AccountDashboard';

  public static ConfigurableDashboards: string[] = [
    DashboardIdentifiers.ClientDashboard,
    DashboardIdentifiers.ClientParentDashboard,
    DashboardIdentifiers.CreditorDashboard,
    DashboardIdentifiers.EstateDashboard,
    DashboardIdentifiers.HeadleaseDashboard,
    DashboardIdentifiers.HomeDashboard,
    DashboardIdentifiers.LandlordDashboard,
    DashboardIdentifiers.LeaseDashboard,
    DashboardIdentifiers.ManagerDashboard,
    DashboardIdentifiers.PropertyDashboard,
    DashboardIdentifiers.TenantDashboard,
    DashboardIdentifiers.TenantParentDashboard,
    DashboardIdentifiers.UnitDashboard,
    DashboardIdentifiers.VacantDashboard,
    DashboardIdentifiers.SupplierDashboard,
    DashboardIdentifiers.DebtorDashboard,
  ];

  public static idToDashboard(identifier: string): Dashboard {
    return identifier ? new Dashboard(identifier, identifier.replace('DashboardComponent', '')) : undefined;
  }

}
